import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalizationService } from '../../shared/services/localization.service';
import { I18nService } from '../../shared/services/i18n.service';

export const localizationInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const countryService = inject(LocalizationService);
  const i18nService = inject(I18nService);

  const localization = countryService.getLocalization();
  const lang = i18nService.getCurrentLang();

  const headers: Record<string, string> = {
    'X-Currency': localization.currency ?? '',
    'X-Language': lang ?? '',
    'Accept-Language': lang ?? '',
  };

  // Only set X-Country/X-State if not already set on the request
  // This allows explicit overrides (e.g., cart refresh for a specific address)
  if (!req.headers.has('X-Country') && localization.country) {
    headers['X-Country'] = localization.country;
  }
  if (!req.headers.has('X-State') && localization.state) {
    headers['X-State'] = localization.state;
  }

  const cloned = req.clone({ setHeaders: headers });
  return next(cloned);
};

